// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { KnownVersions } from "./models.js";
export type { KnowledgeBaseModelWebSummarizationActivityRecord } from "./azure/search/documents/knowledgeBases/models.js";
